import { initGetStartedRed } from '../components/getStartedRed';
import { initIntegrations } from '../components/integrations';
import { initLandingHero } from '../components/landingHero';
import { initSectionScroller } from '../components/sectionScroller';
import { initPricing } from '../components/pricing';
import { initReviewsSlider } from '../components/reviewsSlider';
import { initTrustedBy } from '../components/trustedBy';
import { initWhoChoose } from '../components/whoChoose';
import { initWhyChoose } from '../components/whyChoose';
import { initGetStartedLight } from '../components/getStartedLight';
import { embedHsForm } from '../lib/hsForms';
import { scheduleTask } from '../lib/task';

export function initLandingPage() {
  initLandingHero();
  scheduleTask(initTrustedBy);
  scheduleTask(initIntegrations);
  scheduleTask(initReviewsSlider);
  scheduleTask(initWhoChoose);
  scheduleTask(initWhyChoose);
  scheduleTask(initPricing);

  scheduleTask(initGetStartedLight);
  scheduleTask(initGetStartedRed);
  scheduleTask(initSectionScroller);
  embedHsForm('#hubspotFormContainer');

  console.log('📄 Landing page initialized.');
}
